var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "sidebar-widget",
    },
    [
      _vm.title
        ? _c(
            "div",
            {
              staticClass: "sidebar-widget-header",
            },
            [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar-widget-content",
        },
        [_vm._t("content")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }